<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>Faliújság</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">
<ion-grid>
  <ion-row>
    <ion-col>
      <ion-button  style="float:right;" size="big" color="primary" (click)="initModal(1)">
        <fa-icon icon="plus" slot="start"></fa-icon>&nbsp;Új
      </ion-button>
    </ion-col>
  </ion-row>
<ion-row>
  <ion-col>
      

      <ngx-datatable
        class="ngx-datatable cronomitnew fixed-header fixed-row virtualized scroll-horz selectable checkbox-selection"
        [rows]="faliujsag"
        [sortType]="SortType.single"
        [columnMode]="ColumnMode.force"
        [limit]="10"
        (activate)="onActivate($event)"
        [rowClass]="getRowClass"
        [sorts]="[{ prop: 'created_at', dir: 'desc' },{ prop: 'updated_at', dir: 'desc' },{ prop: 'priority', dir: 'desc' },{ prop: 'deadline', dir: 'desc' }]"
      >
        <ngx-datatable-column name="Prioritás" prop="priority" style="background-color: red !important;">
          <ng-template let-value="value" ngx-datatable-cell-template>
            <strong *ngIf="value==1"><fa-icon icon="arrow-down" style="color:blue"></fa-icon></strong>
            <strong *ngIf="value==2"><fa-icon icon="arrow-up" style="color:green"></fa-icon></strong>
            <strong *ngIf="value==3"><fa-icon icon="arrows-up-to-line" style="color:orange"></fa-icon></strong>
            <strong *ngIf="value==4"><fa-icon icon="triangle-exclamation" style="color:red"></fa-icon></strong>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Létrehozta">
          <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
            {{ row.viselt_vez }} {{ row.viselt_ker }}
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Tárgy" prop="name">
          <ng-template let-value="value" ngx-datatable-cell-template>
            {{ value }}
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Utoljára módosítva" prop="updated_at" >
          <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
            {{ value | date:"yyyy. MM. dd." }}
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Határidő" prop="deadline" >
          <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
            {{ value | date:"yyyy. MM. dd." }}
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Melléklet" prop="attachment" >
          <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
            {{ JSON.parse(value).length }}
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable>


    </ion-col>
  </ion-row>
</ion-grid>




  <ion-modal class="nagy" style="z-index: 1000" #uzenetmodal trigger="uzenet" (willDismiss)="onWillDismiss($event)">
    <ng-template>
      <ion-header>
        <ion-toolbar color="primary">
          <ion-buttons slot="start">
            <ion-button (click)="cancel()" *ngIf="!megnyitott">Mégse</ion-button>
            <ion-button (click)="cancel()" *ngIf="megnyitott">Bezár</ion-button>
          </ion-buttons>
          <ion-title>Faliújság: {{targy}}</ion-title>
          <ion-buttons slot="end">
            <!--ion-button style="background: white; border-radius: 5px" (click)="confirm(1)" [strong]="true" shape="round"
              color="secondary">Piszkozat</ion-button-->
            <ion-button style="background: white; border-radius: 5px" (click)="confirm(0)" [strong]="true"
              [disabled]="validateForm()" shape="round" color="primary" *ngIf="!megnyitott">Küldés</ion-button>
          </ion-buttons>
        </ion-toolbar>
      </ion-header>
      <ion-content class="ion-padding">
        <ion-select *ngIf="!megnyitott" color="primary" value="0" label="Címzett*" labelPlacement="stacked" fill="outline" interface="popover" placeholder="" [(ngModel)]="cimzett">
          <!--ion-select-option value="0">Mindenki</ion-select-option>
          <ion-select-option value="1">Állomány</ion-select-option>
          <ion-select-option value="2">Szülő</ion-select-option-->
          <ion-select-option *ngFor="let item of csoport" [value]="item.id">{{item.name}}</ion-select-option>
        </ion-select>
        <br>
        <ion-select *ngIf="!megnyitott" color="primary" label="Prioritás*" labelPlacement="stacked" fill="outline" interface="popover" placeholder="" [(ngModel)]="prioritas" value="2">
          <ion-select-option value="1">Alacsony</ion-select-option>
          <ion-select-option value="2">Normál</ion-select-option>
          <ion-select-option value="3">Fontos</ion-select-option>
          <ion-select-option value="4">Sürgős</ion-select-option>
        </ion-select>
        <br>
        <ion-input color="primary" fill="outline" label="Prioritás*" labelPlacement="stacked" type="text" placeholder="" *ngIf="megnyitott"
          [(ngModel)]="prio[prioritas]" readonly></ion-input>
        <br>
        <ion-input color="primary" fill="outline" label="Határidő*" labelPlacement="stacked" type="text" placeholder="" *ngIf="megnyitott" readonly
          [(ngModel)]="hatarido"></ion-input>
        <br>
        <ion-input color="primary" fill="outline" label="Tárgy*" labelPlacement="stacked" type="text" placeholder="" [readonly]="megnyitott"
          [(ngModel)]="targy"></ion-input>
        <br>
        <ion-textarea fill="outline" label="Üzenet*" rows="10" labelPlacement="stacked" [counter]="true" [readonly]="megnyitott"
          maxlength="1000" [(ngModel)]="uzenet"></ion-textarea>

          <ion-label fill="outline" position="stacked" *ngIf="!megnyitott">Határidő</ion-label>
          <div style="width: 100%;">
          <ion-datetime #datetime [firstDayOfWeek]="1" presentation="date" style="margin: auto;" [(ngModel)]="hatarido" *ngIf="!megnyitott">
            <ion-buttons slot="buttons">
              <ion-button color="danger" (click)="datetime.reset()">Törlés</ion-button>
            </ion-buttons>
          </ion-datetime>
        </div>

        <ion-label position="stacked">Mellékletek</ion-label>
        <div class="container" appDnd (fileDropped)="onFileDropped($event)" *ngIf="!megnyitott">
          <input type="file" #fileDropRef id="fileDropRef" multiple (change)="fileBrowseHandler($event)" />
          <svg xmlns="http://www.w3.org/2000/svg" width="63" height="64" viewBox="0 0 63 64">
            <g fill="#3B454F" fill-rule="nonzero">
              <path
                d="M42.656 15.135a1.953 1.953 0 0 1-1.391-.578L31.5 4.795l-9.765 9.762a1.97 1.97 0 1 1-2.785-2.785L30.106.616a1.97 1.97 0 0 1 2.785 0l11.157 11.156a1.97 1.97 0 0 1-1.392 3.363z" />
              <path
                d="M31.5 36.791a1.97 1.97 0 0 1-1.969-1.969V2.01a1.97 1.97 0 0 1 3.938 0v32.812a1.97 1.97 0 0 1-1.969 1.969z" />
              <path
                d="M55.781 63.041H7.22A7.225 7.225 0 0 1 0 55.822V41.385a4.599 4.599 0 0 1 4.594-4.594h7.234a4.567 4.567 0 0 1 4.402 3.276l2.814 9.382a.658.658 0 0 0 .628.467h23.656a.658.658 0 0 0 .628-.467l2.814-9.385a4.572 4.572 0 0 1 4.402-3.273h7.234A4.599 4.599 0 0 1 63 41.385v14.437a7.225 7.225 0 0 1-7.219 7.219zM4.594 40.729a.656.656 0 0 0-.657.656v14.437a3.286 3.286 0 0 0 3.282 3.282H55.78a3.286 3.286 0 0 0 3.282-3.282V41.385a.656.656 0 0 0-.657-.656h-7.234a.65.65 0 0 0-.628.467L47.73 50.58a4.628 4.628 0 0 1-4.402 3.274H19.672a4.567 4.567 0 0 1-4.402-3.276l-2.814-9.382a.65.65 0 0 0-.628-.467H4.594z" />
            </g>
          </svg>

          <h3>Húzza ide a fájlokat</h3>
          <h3 style="    margin-bottom: 15px !important;">vagy</h3>
          <label for="fileDropRef">Tallózás</label>
        </div>
        <div class="files-list">
          <div class="single-file" *ngFor="let file of files; let i = index">
            <div class="file-icon" style="width: 50px">
              <img *ngIf="file?.name.slice(-3) == 'pdf'" src="assets/svg/pdf-document-svgrepo-com.svg">
              <img *ngIf="file?.name.slice(-4) == 'html'" src="assets/svg/html-document-svgrepo-com.svg">
              <img *ngIf="file?.name.slice(-3) == 'txt'" src="assets/svg/txt-document-svgrepo-com.svg">
              <img *ngIf="file?.name.slice(-3) == 'doc' || file?.name.slice(-4) == 'docx'"
                src="assets/svg/word-document-svgrepo-com.svg">
              <img *ngIf="file?.name.slice(-3) == 'ppt' ||file?.name.slice(-4) == 'pptx'"
                src="assets/svg/ppt-document-svgrepo-com.svg">
              <img *ngIf="file?.name.slice(-3) == 'xls' ||file?.name.slice(-4) == 'xlsx'"
                src="assets/svg/excel-document-svgrepo-com.svg">
              <img *ngIf="file?.name.slice(-3) == 'zip'" src="assets/svg/zip-document-svgrepo-com.svg">
              <img *ngIf="file?.name.slice(-3) == 'mp4'" src="assets/svg/video-document-svgrepo-com.svg">
              <img
                *ngIf="file?.name.slice(-3) == 'jpg' || file?.name.slice(-3) == 'png'|| file?.name.slice(-4) == 'jpeg'|| file?.name.slice(-3) == 'svg' || file?.name.slice(-3) == 'bmp' "
                src="assets/svg/image-document-svgrepo-com.svg">
              <img src="assets/svg/unknown-document-svgrepo-com.svg">
              <!--svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px" y="0px" viewBox="0 0 58 58" style="enable-background:new 0 0 58 58;" xml:space="preserve">
                <polygon style="fill:#EDEADA;" points="51.5,14 37.5,0 6.5,0 6.5,58 51.5,58 " />
                <g>
                  <path style="fill:#CEC9AE;"
                    d="M16.5,23h25c0.552,0,1-0.447,1-1s-0.448-1-1-1h-25c-0.552,0-1,0.447-1,1S15.948,23,16.5,23z" />
                  <path style="fill:#CEC9AE;"
                    d="M16.5,15h10c0.552,0,1-0.447,1-1s-0.448-1-1-1h-10c-0.552,0-1,0.447-1,1S15.948,15,16.5,15z" />
                  <path style="fill:#CEC9AE;"
                    d="M41.5,29h-25c-0.552,0-1,0.447-1,1s0.448,1,1,1h25c0.552,0,1-0.447,1-1S42.052,29,41.5,29z" />
                  <path style="fill:#CEC9AE;"
                    d="M41.5,37h-25c-0.552,0-1,0.447-1,1s0.448,1,1,1h25c0.552,0,1-0.447,1-1S42.052,37,41.5,37z" />
                  <path style="fill:#CEC9AE;"
                    d="M41.5,45h-25c-0.552,0-1,0.447-1,1s0.448,1,1,1h25c0.552,0,1-0.447,1-1S42.052,45,41.5,45z" />
                </g>
                <polygon style="fill:#CEC9AE;" points="37.5,0 37.5,14 51.5,14 " />
              </svg-->
            </div>
            <div class="info">
              <h4 class="name">
                {{ file?.name }}
              </h4>
              <p class="size">
                {{ formatBytes(file?.size) }}
              </p>
              <app-progress [progress]="file?.progress"></app-progress>
            </div>

            <div class="delete" (click)="deleteFile(i)">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18">
                <path fill="#B1B1B1" fill-rule="nonzero"
                  d="M1 16c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v10zm3.17-7.83a.996.996 0 0 1 1.41 0L7 9.59l1.42-1.42a.996.996 0 1 1 1.41 1.41L8.41 11l1.42 1.42a.996.996 0 1 1-1.41 1.41L7 12.41l-1.42 1.42a.996.996 0 1 1-1.41-1.41L5.59 11 4.17 9.58a.996.996 0 0 1 0-1.41zM10.5 1L9.79.29C9.61.11 9.35 0 9.09 0H4.91c-.26 0-.52.11-.7.29L3.5 1H1c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1h-2.5z" />
              </svg>
            </div>
          </div>
        </div>


      </ion-content>
    </ng-template>
  </ion-modal>
</ion-content>
